/**
 * Utility functions for managing location type filters in session storage
 */

const SESSION_STORAGE_KEYS = {
  PICKUP_LOCATION_TYPE: 'pickup_location_type_filter',
  DROPOFF_LOCATION_TYPE: 'dropoff_location_type_filter',
};

/**
 * Save pickup location type filter to session storage
 * @param {string} locationType - The location type to save
 */
export const savePickupLocationTypeFilter = (locationType) => {
  if (locationType) {
    sessionStorage.setItem(SESSION_STORAGE_KEYS.PICKUP_LOCATION_TYPE, locationType);
  } else {
    sessionStorage.removeItem(SESSION_STORAGE_KEYS.PICKUP_LOCATION_TYPE);
  }
};

/**
 * Save dropoff location type filter to session storage
 * @param {string} locationType - The location type to save
 */
export const saveDropoffLocationTypeFilter = (locationType) => {
  if (locationType) {
    sessionStorage.setItem(SESSION_STORAGE_KEYS.DROPOFF_LOCATION_TYPE, locationType);
  } else {
    sessionStorage.removeItem(SESSION_STORAGE_KEYS.DROPOFF_LOCATION_TYPE);
  }
};

/**
 * Get pickup location type filter from session storage
 * @returns {string|null} The pickup location type or null if not found
 */
export const getPickupLocationTypeFilter = () => {
  return sessionStorage.getItem(SESSION_STORAGE_KEYS.PICKUP_LOCATION_TYPE);
};

/**
 * Get dropoff location type filter from session storage
 * @returns {string|null} The dropoff location type or null if not found
 */
export const getDropoffLocationTypeFilter = () => {
  return sessionStorage.getItem(SESSION_STORAGE_KEYS.DROPOFF_LOCATION_TYPE);
};

/**
 * Clear all location type filters from session storage
 */
export const clearLocationTypeFilters = () => {
  sessionStorage.removeItem(SESSION_STORAGE_KEYS.PICKUP_LOCATION_TYPE);
  sessionStorage.removeItem(SESSION_STORAGE_KEYS.DROPOFF_LOCATION_TYPE);
};

/**
 * Get all location type filters as an object
 * @returns {Object} Object containing pickup and dropoff location type filters
 */
export const getAllLocationTypeFilters = () => {
  return {
    pickupLocationType: getPickupLocationTypeFilter(),
    dropoffLocationType: getDropoffLocationTypeFilter(),
  };
};

/**
 * Check if a location type filter is set
 * @returns {boolean} True if any location type filter is set
 */
export const hasLocationTypeFilters = () => {
  const pickupType = getPickupLocationTypeFilter();
  const dropoffType = getDropoffLocationTypeFilter();
  return !!(pickupType || dropoffType);
};
